<template>
  <v-container>
    <v-layout row wrap>
      <v-flex lg4 md4 sm12 xs12>
        <!--{{singleVolunteer}}-->
        <v-container>
          <v-card flat color="purple" dark>
            <v-container>
              <div class="">
                <p>NAME</p>
                <p class="text-big font-light" style="font-size: 30px;">
                  {{singleVolunteer.title}} {{singleVolunteer.full_name}}
                </p>
              </div>
            </v-container>
          </v-card>
          <br>
          <v-card flat color="yellow" >
            <v-container>
              <div class="">
                <p>COUNTRY</p>
                <p class="text-big font-light" style="font-size: 20px;">
                  {{singleVolunteer.country}}
                </p>
              </div>
            </v-container>
          </v-card>
          <br>
          <v-card flat color="primary" dark>
            <v-container>
              <div class="text-center">
                <p>CONTACTS</p>
                <p class="text-big font-light" style="font-size: 20px;"><b>Email</b> {{singleVolunteer.email}}</p>
                <p class="text-big font-light" style="font-size: 20px;"><b>Phone Number</b> {{singleVolunteer.tel}}</p>
              </div>
            </v-container>
          </v-card>
          <br>
          <v-card flat color="info" dark>
            <v-container>
              <div class="text-center">
                <h3>{{singleVolunteer.payment_status}}</h3>
              </div>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg8 md8 sm12 xs12>
        <v-card flat>
          <v-container>
            <p><b>Gender</b> {{singleVolunteer.gender}}</p>
            <br>
            <p><b>Applicant's Age</b> {{singleVolunteer.age}}</p>
            <p><b>Application Date</b> {{formated_date_time(singleVolunteer.date_of_application)}}</p>
            <p><b>ID/Alien ID/ Passport number</b> {{singleVolunteer.id_alien_number}}</p>
            <p><b>ID/Alien ID/Passport Date of Issue</b> {{formated_date(singleVolunteer.date_of_issue)}}</p>
            <p><b>ID/Alien ID/Passport Expiry Date</b> {{formated_date(singleVolunteer.expiry_date)}}</p>
            <p><b>ID/Alien ID/Passport Place of Issue</b> {{singleVolunteer.place_of_issue}}</p>
            <br>
            <p><b>Postal Address</b> {{singleVolunteer.postal_address}}</p>
            <p><b>Postal Code</b> {{singleVolunteer.postal_code}}</p>
            <br>
            <p><b>Dietary Information</b> {{singleVolunteer.dietary}}</p>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'SingleVolunteerApplication',
  data () {
    return {}
  },
  created () {
    this.$store.dispatch('get_volunteer', this.$route.params.applicant_id)
  }
}
</script>

<style scoped>

</style>
